import { useEffect, useState } from 'react';

import Link from 'next/link';
import Router from 'next/router';
import PropTypes from 'prop-types';

import { warrantyActivationSuccess } from '../../helpers/warranty-activation-segment';
import useI18n from '../../hooks/use-i18n';
import { countryMap } from '../../language.config';

import '../../styles/revamp/warranty-activated-modal.scss';

function WarrantyActivatedModal(props) {
  const { warrantyDetails } = props;

  const i18n = useI18n();
  const warrantyLandingPage = i18n.t('warranty_activation').landing_page;
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';

  const [isMobile, setIsMobile] = useState(false);
  const [dates, setDates] = useState({
    activationDate: '',
    expiryDate: ''
  });

  const handleDateFormat = (date) => {
    const day = new Date(date);
    return (`${day.getDate()}/${(day.getMonth() < 10 ? '0' : '') + (day.getMonth() + 1)}/${day.getFullYear()}`);
  };

  const exitModal = () => {
    Router.push(`/${i18n.activeLocale}/warranty-activation/warranty-device-details?id=${warrantyDetails?.id}`);
  };

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);

  useEffect(() => {
    if (warrantyDetails) {
      warrantyActivationSuccess(countryMap[country], warrantyDetails?.product.name);
      setDates({ activationDate: handleDateFormat(warrantyDetails?.warrantyActivationDate),
        expiryDate: handleDateFormat(warrantyDetails?.warrantyExpirationDate) });
    }
  }, [warrantyDetails]);

  return (
    <div className="warranty-activated-modal-wrapper" role="presentation" onClick={exitModal}>
      <div className="modal-inner" role="presentation" onClick={(e) => e.stopPropagation()}>
        <div className="modal-gradient">
          <div
            className="close-icon"
            role="presentation"
            onClick={exitModal}
          >
            <img
              src="/img/updated/footer/close.svg"
              alt="close-icon"
            />
          </div>
          <div className="warranty-activated-section">
            <img src="/img/warranty/warranty_success.gif" alt="success_icon" data-gumlet="false" />
            <h2
              data-lokalise=""
              data-key="warranty_activation::landing_page::warranty_activated"
            >
              {warrantyLandingPage.warranty_activated}

            </h2>
            <p
              data-lokalise=""
              data-key="warranty_activation::landing_page::device_warranty_will_expire_on"
            >
              {warrantyLandingPage.device_warranty_will_expire_on}
              {' '}
              <span>{dates.expiryDate}</span>
              .
            </p>
            <p
              data-lokalise=""
              data-key="warranty_activation::landing_page::confirmation_email_msg"
            >
              {warrantyLandingPage.confirmation_email_msg}
            </p>
          </div>
          <div className="divider-img" />
          <div className="free-smile-section">
            <img
              src="/img/warranty/free_smile_logo.svg"
              className="free_smile_logo"
              alt="Free Smile Logo"
              data-gumlet="false"
            />
            <h2
              data-lokalise=""
              data-key="warranty_activation::landing_page::free_smile_assessment"
            >
              {warrantyLandingPage.free_smile_assessment}

            </h2>
            <p
              data-lokalise=""
              data-key="warranty_activation::landing_page::free_smile_description"
            >
              {warrantyLandingPage.free_smile_description}

            </p>
            <div className="free-smile-img-container">
              <img
                src={isMobile
                  ? '/img/warranty/warranty_free_smile_mobile.png' : '/img/warranty/warranty_free_smile.png'}
                alt="Warranty Free Smile"
                data-gumlet="false"
              />
            </div>
          </div>
        </div>
        <div className="modal-white-gradient">
          <Link
            href="/[lng]/invisible-braces"
            as={`/${i18n.activeLocale}/invisible-braces`}
          >
            <a
              className="btn web-btn web-btn--fill"
              data-lokalise=""
              data-key="warranty_activation::landing_page::upgrade_smile_btn"
            >
              {' '}
              {warrantyLandingPage.upgrade_smile_btn}

            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default WarrantyActivatedModal;

WarrantyActivatedModal.propTypes = {
  warrantyDetails: PropTypes.shape()
};

WarrantyActivatedModal.defaultProps = {
  warrantyDetails: {}
};
